import * as yup from 'yup';

import { requiredStringField } from '@blockpulse3/web-client/forms';

export const kybSchema = yup.object({
  kbisFile: requiredStringField,
  statusFile: requiredStringField,
});
